import React from 'react';
import SearchContent from './Components';

const SearchPage: React.FC = () => {
  return <SearchContent />;
};

export default SearchPage;
